import { ObstacleSettings } from "../ObstacleSettings";
import { eObstacleType } from "../ObstacleTypes";



export class ShiftingObsSettings extends ObstacleSettings {
    /**
     * (RO) True, pokud prekazka ma moznost hrace zabit. Pokud false, tak se hraci vyhne (zasune se/ zvedne se, ...)
     */
    get deadly(): boolean { return this._deadly; }
    private _deadly: boolean;

    /**
     * (RO) Offset pro vypocet vychozi pozice prekazky. Offset je v jednotkach od zakladni vychozi pozice urcene pres cellId.
     */
    get startPosOffset(): pc.Vec3 { return this._startPosOffset; }
    private _startPosOffset: pc.Vec3;

    /**
     * (RO) True, pokud prekazka je hned po inicializaci na radce viditelna
     */
    get startVisible(): boolean { return this._startVisible; }
    private _startVisible: boolean;

    /**
     * (RO) Vektor urcujici posun prekazky
     */
    get shiftVec(): pc.Vec3 { return this._shiftVec; }
    private _shiftVec: pc.Vec3;

    /**
     * (RO) Vzdalenost od hrace, kdy dojde k zahajeni presunu prekazky
     */
    get shiftPlDisS(): number { return this._shiftPlDisS; }
    private _shiftPlDisS: number;

    /**
     * (RO) Vzdalenost od hrace, kdy dojde k dokonceni presunu prekazky
     */
    get shiftPlDisE(): number { return this._shiftPlDisE; }
    private _shiftPlDisE: number;

    /**
     * (RO) Ease funkce pro vypocet pozice pri presunu
     */
    get shiftEase(): ((k: number) => number) { return this._shiftEase; }
    private _shiftEase: (k: number) => number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(version: number, deadly: boolean, startPosOffset: pc.Vec3, startVisible: boolean, shiftPlDisS: number, shiftPlDisE: number, shiftVec: pc.Vec3, shiftEase: ((k: number) => number)) {
        super(eObstacleType.shifting, version);

        this._deadly = deadly;
        this._startPosOffset = startPosOffset;
        this._startVisible = startVisible;
        this._shiftPlDisS = shiftPlDisS;
        this._shiftPlDisE = shiftPlDisE;
        this._shiftVec = shiftVec;
        this._shiftEase = shiftEase;
    }
}